import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import "./Budget.css";
import axios from 'axios';
import ClientHeader from '../../ClientHeader/ClientHeader';

const Budget = () => {
    const navigate = useNavigate();

    const [billingType, setBillingType] = useState('');
    const [costEstimate, setCostEstimate] = useState("");
    const [hourlyFrom, setHourlyFrom] = useState("");
    const [hourlyTo, setHourlyTo] = useState("");

    const [user, setUser] = useState(null);
    const [jobId, setJobId] = useState(null);

    useEffect(() => {
        const storedUser = JSON.parse(localStorage.getItem('user'));
        setUser(storedUser);
        const storedJob = JSON.parse(localStorage.getItem('job'));
        setJobId(storedJob.jobId);
    }, []);

    useEffect(() => {
        if (jobId) {
            fetchJobDetails(jobId);
        }
    }, [jobId]);

    const fetchJobDetails = async (id) => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/fetch/job/details`, { job_id: id });
            console.log(response);

            if (response.data.result.status === 'success') {
                setBillingType(response.data.result.job.billing_type);

                const budget = response.data.result.job.budget;
                if (budget.includes('-')) {
                    const [from, to] = budget.split('-').map(value => value.trim());
                    setHourlyFrom(from);
                    setHourlyTo(to);
                } else {
                    setCostEstimate(budget);
                }
            } else {
                console.error(response.data.result.message);
            }
        } catch (error) {
            console.error('Error fetching job details:', error);
        }
    };

    const handleBillingTypeChange = (e) => {
        setBillingType(e.target.value);
    };

    const handleCostEstimateChange = (e) => {
        setCostEstimate(e.target.value);
    };

    const handleHourlyFromChange = (e) => {
        setHourlyFrom(e.target.value);
    };

    const handleHourlyToChange = (e) => {
        setHourlyTo(e.target.value);
    };

    // const handleNext = () => {
    //     navigate('/client/new_project/description');
    // };

    const handleNext = async () => {
        const budget = billingType === "Fixed Price" ? costEstimate : `${hourlyFrom}-${hourlyTo}`;
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/job/update`, {
                job_id: jobId,
                budget: budget,
                billingType: billingType,
            }, {
                headers: {
                    'Content-Type': 'application/json',
                }
            });

            if (response.data.result.status === 'success') {
                navigate('/client/project/description');
            } else {
                console.error(response.data.result.message);
            }
        } catch (error) {
            console.error('Error updating job details:', error);
        }
    };


    const handleBack = () => {
        navigate('/client/project/scope');
    };

    return (
        <div className="budget-container">
            <ClientHeader />

            <div className="budget-content">
                <div className="progress">4/5</div>
                <h2>Tell us about your budget.</h2>
                <p className="description">This will help us match you to talent within your range.</p>

                <div className="billing-type-options">
                    <label className={`billing-type-option ${billingType === "Hourly" ? "active" : ""}`}>
                        <div className="option-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                <path d="M15.9974 31.3337C7.52921 31.3337 0.664062 24.4685 0.664062 16.0003C0.664062 7.53214 7.52921 0.666992 15.9974 0.666992C24.4656 0.666992 31.3307 7.53214 31.3307 16.0003C31.3307 24.4685 24.4656 31.3337 15.9974 31.3337ZM17.3913 6.93972H14.6035V16.5774L20.1792 22.1532L22.1502 20.1821L17.3913 15.4232V6.93972Z" fill="#1B1919" />
                            </svg>
                        </div>
                        <span className="option-name">
                            <span>Hourly</span>
                        </span>
                        <input
                            type="radio"
                            name="billingType"
                            value="Hourly"
                            checked={billingType === "Hourly"}
                            onChange={handleBillingTypeChange}
                        />

                    </label>
                    <label className={`billing-type-option ${billingType === "Fixed Price" ? "active" : ""}`}>
                        <div className="option-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M23.3297 4.43867L26.2526 7.36159C30.5476 11.6581 32.6942 13.8048 32.6942 16.4721C32.6942 19.1411 30.5476 21.2878 26.2526 25.5827C21.9561 29.8792 19.8094 32.0259 17.1405 32.0259C14.4731 32.0259 12.3249 29.8792 8.02993 25.5843L5.10701 22.6614C2.6393 20.1921 1.40465 18.959 0.946245 17.357C0.486245 15.755 0.879161 14.0539 1.66499 10.6535L2.11701 8.69207C2.77666 5.82985 3.10729 4.39874 4.08638 3.41804C5.06708 2.43895 6.49819 2.10832 9.36041 1.44867L11.3218 0.995058C14.7239 0.210822 16.4233 -0.182095 18.0253 0.276308C19.6274 0.736308 20.862 1.97096 23.3297 4.43867ZM15.358 19.772C14.283 18.6987 14.291 17.1558 14.9347 15.9339C14.7754 15.7037 14.7017 15.425 14.7264 15.1461C14.7511 14.8673 14.8728 14.6059 15.0701 14.4074C15.2675 14.2089 15.5282 14.0857 15.8069 14.0594C16.0856 14.0331 16.3647 14.1052 16.5958 14.2632C17.1389 13.9757 17.7346 13.8223 18.3288 13.8287C18.6465 13.8317 18.95 13.9608 19.1726 14.1875C19.3951 14.4143 19.5185 14.7201 19.5155 15.0378C19.5126 15.3555 19.3835 15.6591 19.1568 15.8816C18.93 16.1042 18.6242 16.2275 18.3065 16.2246C17.9366 16.2382 17.5871 16.3972 17.3337 16.667C16.7156 17.2851 16.8769 17.9048 17.051 18.0789C17.2267 18.253 17.8449 18.4144 18.463 17.7962C19.7152 16.544 21.8778 16.1287 23.2626 17.5135C24.3376 18.5885 24.3296 20.1314 23.6859 21.3533C23.8442 21.5835 23.9171 21.8618 23.8919 22.1401C23.8668 22.4184 23.7451 22.6791 23.548 22.8771C23.3509 23.0752 23.0907 23.1981 22.8126 23.2246C22.5344 23.2511 22.2558 23.1796 22.0248 23.0223C21.308 23.4155 20.4766 23.5465 19.6737 23.3929C19.3623 23.3289 19.0891 23.1439 18.9142 22.8785C18.7393 22.6131 18.6769 22.2891 18.7409 21.9778C18.8049 21.6664 18.9899 21.3932 19.2553 21.2183C19.5207 21.0434 19.8447 20.981 20.156 21.045C20.4387 21.1041 20.8955 21.0114 21.2869 20.6201C21.905 20.0004 21.7437 19.3823 21.5696 19.2082C21.3939 19.0341 20.7758 18.8728 20.1576 19.4909C18.9054 20.7431 16.7428 21.1584 15.358 19.772ZM13.5595 13.3272C13.8561 13.0305 14.0913 12.6783 14.2518 12.2907C14.4123 11.9031 14.4948 11.4877 14.4948 11.0682C14.4947 10.6487 14.412 10.2333 14.2514 9.84572C14.0908 9.45817 13.8554 9.10605 13.5587 8.80947C13.262 8.51288 12.9098 8.27764 12.5222 8.11716C12.1346 7.95669 11.7192 7.87414 11.2997 7.87421C10.8802 7.87429 10.4648 7.95699 10.0772 8.1176C9.68967 8.2782 9.33755 8.51357 9.04097 8.81027C8.44198 9.40946 8.10556 10.2221 8.10571 11.0693C8.10586 11.9165 8.44257 12.729 9.04177 13.328C9.64096 13.927 10.4536 14.2634 11.3008 14.2633C12.148 14.2631 12.9605 13.9264 13.5595 13.3272Z" fill="#1B1919" />
                            </svg>
                        </div>
                        <span className="option-name">
                            <span>Fixed Price</span>
                        </span>
                        <input
                            type="radio"
                            name="billingType"
                            value="Fixed Price"
                            checked={billingType === "Fixed Price"}
                            onChange={handleBillingTypeChange}
                        />
                    </label>
                </div>

                <div className="billing-info">
                    {billingType === "Hourly" && <div className="hourly-billing">
                        <div style={{ display: 'flex', flexDirection: 'row', gap: '20px', marginTop: '20px' }}>
                            <div className="hourly-billing-input">
                                <label>From</label>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <input type="number"
                                        placeholder="$ 0.00"
                                        value={hourlyFrom}
                                        onChange={handleHourlyFromChange}
                                    />
                                    <span style={{ fontSize: '20px', color: 'black', marginLeft: '5px' }}>/hr</span>
                                </div>
                            </div>
                            <div className="hourly-billing-input">
                                <label>To</label>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <input type="number"
                                        placeholder="$ 0.00"
                                        value={hourlyTo}
                                        onChange={handleHourlyToChange}
                                    />
                                    <span style={{ fontSize: '20px', color: 'black', marginLeft: '5px' }}>/hr</span>
                                </div>
                            </div>
                        </div>

                        <h6>This is the average rate for similar projects.</h6>
                    </div>}

                    {billingType === "Fixed Price" && <div className="fixed-billing">
                        <p className="detail">Set a price for the project and pay at the end, or you can divide the project into milestones and pay as each milestone is completed.</p>

                        <div className="cost-estimate">
                            <label htmlFor="cost-input">
                                What is the best cost estimate for your project?
                            </label>
                            <p>You can negotiate this cost and create milestones when you chat with your Odoo Buddy</p>
                            <input
                                type="number"
                                id="cost-input"
                                placeholder="0.00"
                                value={costEstimate}
                                onChange={handleCostEstimateChange}
                            />
                        </div>
                    </div>}
                </div>


            </div>

            <div className="navigation-buttons">
                <button className="back-button" onClick={handleBack}>Back</button>
                <button className="next-button" onClick={handleNext}>Next</button>
            </div>
        </div>
    );
};

export default Budget;
